import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

const optionToSlug = (option) => option.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

const Daysfilterdropdown = ({
  selectedOption,
  setSelectedOption,
  "data-testid": dataTestId = "days-filter-dropdown",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const options = ["Last 24 Hrs", "Last 7 Days", "Last 30 Days"];
  const dropdownRef = useRef(null);
  const location = useLocation(); // React Router

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const containerClass = `hoursHolder h-9 basis-36 rounded-md bg-[#FFFFFFDE] dark:darkThemeGradiantBg justify-between ${location.pathname === "/dashboard" ? "shadow-none border border-[#292D321F]" : "shadow-appShadow"
    } flex flex-1 relative px-3 py-2 gap-2 max-[430px]:w-full`;

  return (
    <>
      <div className={containerClass} ref={dropdownRef} data-testid={dataTestId}>
        <div
          className="bg-white dark:bg-transparent grow leading-5 text-sm font-medium shadow-none text-dark-grey dark:text-white tracking-[0.021px] cursor-pointer whitespace-nowrap"
          onClick={() => setIsOpen((prev) => !prev)}
          data-testid={`${dataTestId}-trigger`}
        >{selectedOption}</div>
        <div className="dropdownIconHolder static h-full flex items-center cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 9L12 15L5 9" stroke="black" stroke-opacity="0.87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className="dark:stroke-white"/>
          </svg>
        </div>
        {isOpen && (
          <div className="dropdownMenuHolder dark:bg-darkThemeDropdownBg dark:shadow-darkThemeDropdownMenuShadow absolute top-full mt-2 right-0 shadow-appShadow block w-full rounded-md z-50" data-testid={`${dataTestId}-menu`}>
            <ul className="bg-white dark:bg-transparent rounded-lg w-full">
              {options.map((option, index) => (
                <li
                  key={option}
                  onClick={() => handleOptionClick(option)}
                  className={`px-3 py-2.5 text-black dark:text-white text-xs text-left leading-4 lg:text-sm lg:leading-5 font-normal tracking-[-0.408px] border-b border-grey last:border-0 dark:border-darkThemeBorder flex justify-between items-center gap-2 cursor-pointer ${selectedOption === option ? "bg-[#FFF1C6] dark:bg-darkThemeDropdownItemBg" : ""
                    } ${index === options.length - 1 ? "border-0" : ""}`}
                  data-testid={`${dataTestId}-option-${optionToSlug(option)}`}
                >
                  <span>{option}</span>
                  {selectedOption === option && (
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M8.49215 15C8.24102 15 8.00244 14.8995 7.82665 14.7238L4.27311 11.1702C3.90896 10.8061 3.90896 10.2033 4.27311 9.8392C4.63725 9.47506 5.23997 9.47506 5.60412 9.8392L8.49215 12.7272L14.9463 6.27311C15.3104 5.90896 15.9132 5.90896 16.2773 6.27311C16.6414 6.63725 16.6414 7.23997 16.2773 7.60412L9.15766 14.7238C8.98186 14.8995 8.74329 15 8.49215 15Z"
                          fill="#FF8C65"
                        ></path>
                      </svg>
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  )
}

export default Daysfilterdropdown;